<div *ngIf="showHeader" id="navbar" class="navbar app-ic-header d-block  toggle-color navbar-expand-lg fixed-top z-index-999 navbar-dark">
    <div class="row no-gutters align-items-center">
        <div *ngIf="!newTopMenu" class="col-2 col-lg-3 col-md-2">
            <div *ngIf="showHeader" id="logo-bg" class="logo logo pointer d-inline-block text-center"
                [ngClass]="{'slick-disabled':router.url.includes('/preview') && router.url.includes('/channel/')}"
                (click)="goToGroup()">
                <img *ngIf="(org_info?.channel_logo || settingsData?.channelInfo?.channel_logo) && settingsData?.channelInfo?.channel_id == 0 "
                    src="{{org_info?.channel_logo}}">
                <img *ngIf="settingsData?.channelInfo?.channel_logo && settingsData?.channelInfo?.channel_id != 0"
                    src="{{settingsData.channelInfo.channel_logo}}">
                <img *ngIf="!settingsData?.channelInfo?.channel_logo && org_info?.channel_logo && settingsData?.channelInfo?.channel_id != 0"
                    src="{{org_info.channel_logo}}">
                <img *ngIf="org_info?.organization_logo && !org_info?.channel_logo && !settingsData?.channelInfo?.channel_logo"
                    src="{{org_info?.organization_logo}}">
            </div>
        </div>
        <div class="text-right" [ngClass]="newTopMenu ? 'col-12' : 'col-10 col-md-10 col-lg-9'">
            <app-ic-top-menu *ngIf="newTopMenu"
                [settingsData]="settingsData" [logoUrl]="headerLogoUrl"
                [logoDisabled]="router.url.includes('/preview') && router.url.includes('/channel/')"
                [isPreview]="router.url.includes('/preview')" [disableAccess]="disableAccess"
                [isNative]="appType == 'native'" [marketplaceText]="marketplacetext"
                [showCommunity]="enableCommunity && communityAccess" [show247]="show247Channel"
                [showAffiliate]="showAffiliateLink"
                [affiliateLabel]="isAffiliate ? 'Sign in as Affiliate' : 'Become an Affiliate'"
                [showCurrency]="showCurrencySelector" [currency]="currency" [currencyList]="currencyJSON"
                [showCart]="showCartButton" [cartCount]="cartProdCount"
                [showSignIn]="!loggedIn && !userIdParam && appType != 'native'"
                [showAvatar]="!userInfo?.is_guest && loggedIn && appType != 'native'"
                [profilePic]="userInfo?.profile_pic" [initials]="displayName | uppercase"
                [(searchText)]="searchKeyWords" (searchTextChange)="suggestTopMenuSearch($event)" (search)="searchDataOnEnter()"
                [suggestions]="topMenuSuggestions" [suggestionsLoading]="topMenuSuggestionsLoading" [suggestionsFailed]="topMenuSuggestionsFailed" (pickSuggestion)="openTopMenuSuggestion($event)"
                [scrolled]="menuScrolled" [events]="topMenuEvents" [recentSearches]="recentSearches"
                (eventsNeeded)="loadTopMenuEvents()" (openEvent)="openTopMenuEvent($event)"
                (logoClick)="goToGroup()" (marketplaceSelect)="getlink($event)"
                (community)="navigateToCommunity()" (channel247)="click24_7Channel()"
                (affiliate)="clickAffiliateLink(affiliateKey)" (currencyChange)="changeCurrency($event)"
                (cartClick)="goToCartBox()" (signIn)="redirectTo('signin')" (profileToggle)="rightsidenav.toggle()">
                <app-cart-popup cartPopup *ngIf="copyLinkPopup && cartProdCount > 0" class="position-ab-da"
                    [products]="cartProducts" [count]="cartProdCount" [settingsData]="settingsData" [userInfo]="userInfo"
                    (closed)="closePopup()" (checkout)="gotoCheckout()" (removed)="onCartItemsRemoved($event)" (openProduct)="openCartProduct($event)">
                </app-cart-popup>
            </app-ic-top-menu>

            <ng-container *ngIf="!newTopMenu">
                <!-- mobile view -->
                <div class="d-lg-none d-md-none d-inline-block aftersignin">
                    <div class="h-searchbox mr-3 text-right relative d-inline-block" *ngIf="!isShownSettings" [ngStyle]="{'background-color': settingsData.bg_primary_color ? settingsData.bg_primary_color : null ,'color': settingsData.font_primary_color ? settingsData.font_primary_color : null ,
                    'font-family': settingsData.font_family ? settingsData.font_family : null  }">
                        <input type="text" class="h-search w-100" [(ngModel)]="searchKeyWords"
                            [disabled]="router.url.includes('/preview')" placeholder="Search..."
                            (keyup.enter)="searchDataOnEnter()" [ngStyle]="{'background-color': settingsData.bg_primary_color ? settingsData.bg_primary_color : null ,'color': settingsData.font_primary_color ? settingsData.font_primary_color : null ,
                            'font-family': settingsData.font_family ? settingsData.font_family : null  }">
                        <i class="fa fa-search s-h-icon pointer" [ngClass]="{'slick-disabled':disableAccess}" [disabled]="disableAccess" (click)="!disableAccess ? searchDataOnEnter() : ''"></i>
                    </div>
                    <!-- *ngIf = "isShownSettings" -->
                    <ng-container *ngIf="isShownSettings">
                        <div class=" d-inline-block" *ngIf="appType !='native'">
                            <div class="pt-0 mr-3">
                                <app-google-translate></app-google-translate>
                            </div>
                        </div>

                        <div class="mr-3 dropdown app-currency d-inline-block"
                            *ngIf="(router.url.includes('/subscription-list') || router.url.includes('/album')) && !router.url.includes('/preview')">
                            <span class="btn btn-primary btn-primary-mobile-resp dropdown-toggle gt-toggle"
                                type="button" (click)="clearSearch()" id="dropdownMenuButton2" data-toggle="dropdown"
                                aria-haspopup="true" aria-expanded="false">
                                <span class="d-inline-block w-150p notranslate">
                                    <span *ngIf="currency?.length <= 4" class="active-color v-bottom">{{ currency
                                        }}</span>
                                    <span *ngIf="currency?.length > 4" class="active-color v-bottom">
                                        {{ currency | slice: 0:4 }}
                                        {{currency?.length > 4 ? "" : ""}}
                                    </span></span>
                            </span>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton2"
                                [ngStyle]="{'background-color': settingsData.bg_primary_color ? settingsData.bg_primary_color : null}">
                                <div class="relative">
                                    <input type="text" placeholder="Search.." class="search-input"
                                        [(ngModel)]="searchCurrency">
                                    <i class="fa fa-search  text-white d-search" aria-hidden="true"></i>
                                </div>
                                <div class="dropdown-div">
                                    <span
                                        *ngFor="let currency of currencyJSON | filter: searchCurrency:'currency';let i=index"
                                        class="notranslate"
                                        [ngStyle]="{'background-color': settingsData.main_bg_color ? settingsData.main_bg_color : null}">
                                        <a class="dropdown-item fs-13"
                                            (click)="changeCurrency(currency.currency)">{{currency.currency}}</a></span>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <div class="fa fa-search icon" [ngClass]="{'slick-disabled':router.url.includes('/preview')}"
                        *ngIf="isShownSettings" (click)="settings()"></div>
                    <div *ngIf="!isShownSettings && appType !='native'" class="fa fa-cog icon" (click)="settings()">
                    </div>

                    <div class="d-md-inline-block d-inline-block" id="side_nav" *ngIf="appType !='native'">
                        <span *ngIf="!loggedIn && !userIdParam" class="search-icon-bg align-middle"
                            [ngClass]="{'slick-disabled':router.url.includes('/preview')}"
                            (click)="redirectTo('signin')">
                            <i class="fa fa-user"></i>
                        </span>
                        <span fxShow id="arevea_mobile_nav" class="artist-pic m-0 text-center pointer aling-middle"
                            (click)="rightsidenav.toggle()"
                            *ngIf="!userInfo?.is_guest && loggedIn && userInfo?.profile_pic != null && userInfo.profile_pic !=''"
                            [ngClass]="{'slick-disabled':router.url.includes('/preview')}"
                            [ngStyle]="{'background-image':' url(' + userInfo?.profile_pic + ')'}"></span>
                        <button fxShow id="side_nav_mobile" class="profile-pic notranslate lh-31"
                            (click)="rightsidenav.toggle()"
                            *ngIf="!userInfo?.is_guest && loggedIn && (userInfo?.profile_pic == null || userInfo?.profile_pic == '')"
                            [ngClass]="{'slick-disabled':router.url.includes('/preview')}"
                            [ngStyle]="{'background-color': settingsData.bg_primary_color ? settingsData.bg_primary_color : null ,'color': settingsData.font_primary_color ? settingsData.font_primary_color : null  }">
                            {{displayName |uppercase}}
                        </button>
                    </div>
                </div>

                <!-- desktop view -->
                <div *ngIf="showHeader" class="d-none d-lg-inline-flex d-md-inline-flex" >
                    
                    <div [ngStyle]="{'background-color': settingsData.bg_tertiary_color ? settingsData.bg_tertiary_color : null ,'color': settingsData.font_tertiary_color ? settingsData.font_tertiary_color : null ,
                    'font-family': settingsData.font_family ? settingsData.font_family : null  }"
                        class="h-searchbox mr-1 ml-1 text-right relative d-inline-block align-self-center">
                        <input [ngStyle]="{'background-color': settingsData.bg_tertiary_color ? settingsData.bg_tertiary_color : null ,'color': settingsData.font_tertiary_color ? settingsData.font_tertiary_color : null ,
                        '--font-family': settingsData.font_family ? settingsData.font_family : null ,'--placeholder-color': settingsData.font_tertiary_color || null
                    }" type="text" class="h-search w-100 dynamic-placeholder" [(ngModel)]="searchKeyWords"
                            [ngClass]="{'slick-disabled':router.url.includes('/preview')}"
                            [disabled]="router.url.includes('/preview')" placeholder="Search..."
                            (keyup.enter)="searchDataOnEnter()">
                        <i class="fa fa-search s-h-icon pointer" [ngClass]="{'slick-disabled':disableAccess}" [disabled]="disableAccess" (click)="!disableAccess ? searchDataOnEnter() : ''"></i>
                    </div>
                    <!-- cart icon -->
                    <div class="w-98 d-flex align-items-center"
                        *ngIf="showCartIcon && cartProdCount > 0 && !router.url.includes('merchandise/product-cart') && !router.url.includes('/merchandise/product-shipping')">
                        <span (click)="cartProdCount > 0 ? goToCartBox() : false" class="cart-icon">
                            <i class="fa fa-shopping-cart" style="font-size:24px" [ngStyle]="{'color': settingsData.font_primary_color}">
                            </i><span class="badge badge-light" [ngStyle]="{'background-color': settingsData.bg_primary_color,'color': settingsData.font_primary_color}"> {{cartProdCount}} </span>
                        </span>
                     </div>

                     <app-cart-popup *ngIf="copyLinkPopup && cartProdCount > 0" class="position-ab-da"
                        [products]="cartProducts" [count]="cartProdCount" [settingsData]="settingsData" [userInfo]="userInfo"
                        (closed)="closePopup()" (checkout)="gotoCheckout()" (removed)="onCartItemsRemoved($event)" (openProduct)="openCartProduct($event)">
                     </app-cart-popup>
                    <div class="dropdown marketplace1 d-none d-md-block mr-5 pointer" [ngClass]="userInfo?.id ? 'center-btn':'center-adjust'" [ngStyle]="{
                        'background-color': settingsData.bg_primary_color,
                        'color': settingsData.font_primary_color,
                        'font-family': settingsData.font_family,
                        'line-height': '8px',
                        'margin-top': '3px',
                        'height': '29px',
                        'border-radius': '8px',
                    }">
                        <a class=" dropdown-toggle text-color" id="dropdownMenuButton" 
                        (click)="!disableAccess ? $event.preventDefault() : $event.stopPropagation();" data-toggle="dropdown" [ngClass]="{'slick-disabled':disableAccess}" [style.color]="settingsData?.font_primary_color + '!important'"
                            aria-haspopup="true" aria-expanded="false">
                            {{marketplacetext == ''? 'Marketplace':marketplacetext}}
                        </a>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" [style.--marketplace-bg]="settingsData?.bg_tertiary_color" [style.--marketplace-font]="settingsData?.font_tertiary_color">
                            <a class="dropdown-item"  routerLinkActive="bg-active"
                                (click)="getlink('market')">Merchandise</a>
                            <a class="dropdown-item"  routerLinkActive="bg-active"
                                (click)="getlink('event')">Events</a>
                        </div>
                    </div>

                    <div *ngIf="enableCommunity && communityAccess" class="community mr-5 plr-10 pt-0 d-inline-block align-self-center pointer" [ngClass]="{
                        'btn-primary': !settingsData?.bg_primary_color,
                        'slick-disabled': disableAccess
                    }" [ngStyle]="{
                        'background-color': settingsData.bg_primary_color,
                        'color': settingsData.font_primary_color,
                        'font-family': settingsData.font_family,
                        'line-height': '0',
                        'border-radius': '8px',
                    }" (click)="!disableAccess ? navigateToCommunity() : ''">
                        <span>
                            <p class="pb-2 mt-14">Community</p>
                        </span>
                    </div>
                    <div *ngIf="show247Channel" class="community mr-5 plr-10 pt-0 d-inline-block align-self-center"
                            [ngClass]="{'btn-primary': !settingsData?.bg_primary_color,
                                            'slick-disabled': router.url.includes('/preview')
                                        }" [ngStyle]="{
                                            'background-color': settingsData.bg_primary_color,
                                            'color': settingsData.font_primary_color,
                                            'font-family': settingsData.font_family,
                                            'line-height': '0',
                                            'border-radius': '8px',
                                            'cursor': 'pointer',
                                        }" (click)="click24_7Channel()">
                        <span>
                            <p class="pb-2 mt-14">
                                24/7 Channel
                            </p>
                        </span>
                    </div>
                    <!-- event button -->
                    <!-- <div  class="community mr-5 plr-10 pt-0 d-inline-block align-self-center" [ngClass]="{
                        'btn-primary': !settingsData?.bg_primary_color,
                        'slick-disabled': router.url.includes('/preview')
                    }" [ngStyle]="{
                        'background-color': settingsData.bg_primary_color,
                        'color': settingsData.font_primary_color,
                        'font-family': settingsData.font_family,
                        'line-height': '0',
                        'border-radius': '8px',
                        'cursor': 'pointer',
                    }" (click)="navigateToEvent()">
                        <span>
                            <p class="pb-2 mt-14">Event</p>
                        </span>
                    </div> -->

                    <div *ngIf="organizationKey && loggedIn" class="community mr-5 plr-10 pt-0 d-inline-block align-self-center" [ngClass]="{
                        'btn-primary': !settingsData?.bg_primary_color,
                        'slick-disabled': router.url.includes('/preview')
                    }" [ngStyle]="{
                        'background-color': settingsData.bg_primary_color,
                        'color': settingsData.font_primary_color,
                        'font-family': settingsData.font_family,
                        'line-height': '0',
                        'border-radius': '8px',
                        'cursor': 'pointer',
                    }" (click)="clickAffiliateLink(affiliateKey)">
                       <span *ngIf="isAffiliate || isGroupAffiliate || (fanPrograms?.length > 0)">
                        <p class="pb-2 mt-14">
                          {{ isAffiliate ? 'Sign in as Affiliate' : 'Become an Affiliate' }}
                        </p>
                      </span>
                      
                    </div>

                    <!-- <span class="pr-10 m-auto mr-4" fxhide.xs="true" fxshow=""
                    [ngClass]="{'btn-primary': !settingsData?.bg_primary_color}" [ngStyle]="settingsData?.bg_primary_color ? {
                        'background-color': settingsData.bg_primary_color,
                        'color': settingsData.font_primary_color,
                        'font-family': settingsData.font_family,
                        'line-height': '1',
                        'border-radius': '8px'
                      } : {}"
                    >
                        <a (click)="gotoCommunities()" class="mr- ml-2 pointer" routerlinkactive="active">Communities</a>
                    </span> -->
                    <div class="pt-9 ptr-9 pr-1 d-inline-block align-self-center" fxShow fxHide.xs="true"
                        [ngClass]="{'slick-disabled':router.url.includes('/preview')}">
                        <app-google-translate [settingsData]="settingsData"></app-google-translate>
                    </div>
                    <div class="dropdown app-currency d-inline-block align-self-center" fxShow fxHide.xs="true"
                        *ngIf="(router.url.includes('/subscription-list') || router.url.includes('/album') || (router.url.includes('/merchandise') && !router.url.includes('merchandise/product-shipping')) || leftMenu) && (!router.url.includes('/preview')) ">
                        <span [ngClass]="{'btn-primary': !settingsData?.bg_primary_color}" [ngStyle]="settingsData?.bg_primary_color ? {
                          'background-color': settingsData.bg_primary_color,
                          'color': settingsData.font_primary_color,
                          'font-family': settingsData.font_family,
                          'line-height': '1',
                          'border-radius': '8px'
                        } : {}" class="btn btn-primary btn-primary-mobile-resp dropdown-toggle gt-toggle" type="button"
                            (click)="clearSearch()" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true"
                            aria-expanded="false">
                            <span class="d-inline-block w-150p notranslate">
                                <span *ngIf="currency?.length <= 4" class="active-color v-bottom">{{ currency }}</span>
                                <span *ngIf="currency?.length > 4" class="active-color v-bottom">
                                    {{ currency | slice: 0:4 }}
                                </span>
                            </span>
                        </span>

                        <div  class="dropdown-menu " aria-labelledby="dropdownMenuButton2" 
                        [ngStyle]="{
                        '--scroll-color': settingsData?.font_tertiary_color || '#888',
                        '--hover-bg': settingsData?.bg_secondary_color,
                        '--hover-color': settingsData?.font_secondary_color}">
                            <div class="relative">
                                <input type="text" [ngStyle]="{'font-family': settingsData.font_family ? settingsData.font_family : null ,'background-color': settingsData.bg_tertiary_color ? settingsData.bg_tertiary_color : null 
                                    }"
                                    [style.color]="settingsData?.font_tertiary_color + '!important'"
                                    placeholder="Search.." class="search-input" [(ngModel)]="searchCurrency">
                                <i class="fa fa-search  text-white d-search" aria-hidden="true"></i>
                            </div>
                            <div class="dropdown-div">
                                <span
                                    *ngFor="let currency of currencyJSON | filter: searchCurrency:'currency';let i=index"
                                    class="notranslate">
                                    <a class="dropdown-item fs-13" [ngStyle]="{'background-color': settingsData.bg_tertiary_color ? settingsData.bg_tertiary_color : null ,'color': settingsData.font_tertiary_color ? settingsData.font_tertiary_color : null ,
                                    'font-family': settingsData.font_family ? settingsData.font_family : null  }"
                                        (click)="changeCurrency(currency.currency)">{{currency.currency}}</a></span>
                            </div>
                        </div>
                    </div>
                    <!-- <button mat-button color="primary" (click)="redirectTo('signup')" *ngIf="!loggedIn && !userIdParam"  [ngClass]="{'slick-disabled':router.url.includes('/preview')}"  class="flat-primary-button br-30 mr-1 ml-1" [ngStyle]="{'background-color': settingsData.bg_primary_color ? settingsData.bg_primary_color : null ,'color': settingsData.font_primary_color ? settingsData.font_primary_color : null ,
                'font-family': settingsData.font_family ? settingsData.font_family : null  }">Sign Up</button> -->
                    <button mat-button="accent" *ngIf="!loggedIn && !userIdParam"
                        [ngClass]="{'slick-disabled':router.url.includes('/preview')}"
                        class="b-flat-primary-button ml-2" (click)="redirectTo('signin')" [ngStyle]="{'background-color': settingsData.bg_primary_color ? settingsData.bg_primary_color : null ,'color': settingsData.font_primary_color ? settingsData.font_primary_color : null ,
                    'font-family': settingsData.font_family ? settingsData.font_family : null  }">
                        <div [ngStyle]="{'background-color': settingsData.bg_primary_color ? settingsData.bg_primary_color : null ,'color': settingsData.font_primary_color ? settingsData.font_primary_color : null ,
                        'font-family': settingsData.font_family ? settingsData.font_family : null  }">Sign In / Up
                        </div>
                    </button>

                    <div fxShow fxHide.xs="true" id="arevea_sideNav" class="artist-pic ml-2 text-center pointer"
                        (click)="rightsidenav.toggle()"
                        *ngIf="!userInfo?.is_guest && loggedIn && userInfo?.profile_pic != null && userInfo.profile_pic !=''"
                        [ngClass]="{'slick-disabled':router.url.includes('/preview')}"
                        [ngStyle]="{'background-image':' url(' + userInfo?.profile_pic + ')','position':'static'}">
                    </div>
                    <button fxShow fxHide.xs="true" id="arevea_sideNav" class="profile-pic notranslate ml-5 mr-10 lh-31"
                        (click)="rightsidenav.toggle()"
                        [ngStyle]="{'background-color': settingsData.bg_primary_color ? settingsData.bg_primary_color : null ,'color': settingsData.font_primary_color ? settingsData.font_primary_color : null, 'position':'static' }"
                        *ngIf="!userInfo?.is_guest && loggedIn && (userInfo?.profile_pic == null || userInfo?.profile_pic == '')"
                        [ngClass]="{'slick-disabled':router.url.includes('/preview')}">
                        {{displayName |uppercase}}
                    </button>
                </div>
            </ng-container>

            <mat-sidenav-container id="arevea_sideNav" class="Top-bar rightsidenav-parent"
                [ngStyle]="{'background-color': settingsData.main_bg_color?settingsData.main_bg_color:'','color': settingsData.font_primary_color ? settingsData.font_primary_color : ''}">
                <mat-sidenav #rightsidenav mode="push" class="fs-16 text-center" [class.tm-side]="newTopMenu" position="end"
                    [style.--menu-text]="settingsData.form_font_secondary_color || null"
                    [style.--menu-open-bg]="settingsData.bg_primary_color || null"
                    [style.--menu-open-text]="settingsData.font_primary_color || null"
                    [style.--menu-active]="menuActiveColor"
                    [ngStyle]="newTopMenu ? sideMenuVars : {'background-color': settingsData.form_bg_color?settingsData.form_bg_color:'','color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : ''}">
                    <mat-icon class="close_button mr-2 mt-1"
                        [ngStyle]="{'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : ''}"
                        (click)="rightsidenav.close()">close
                    </mat-icon>
                    <div class="row mt-30">
                        <!-- <button class="f-l  text-white mt-15 wh-40 pb-5 ml-30" mat-fab>{{displayName}}</button> -->
                        <div class="col-md-3  col-xs-3 pl-40">
                            <div class="profile-pic notranslate m-0"
                                *ngIf="!userInfo?.is_guest && userInfo?.profile_pic != null && userInfo.profile_pic !=''"
                                [ngStyle]="{'background-image':' url(' + userInfo?.profile_pic + ')'}"></div>
                            <button class="profile-pic notranslate f-l bg-yp-0"
                                *ngIf="!userInfo?.is_guest && loggedIn && (userInfo?.profile_pic == null || userInfo.profile_pic =='')"
                                [ngStyle]="{'background-color': settingsData.bg_primary_color ? settingsData.bg_primary_color : null ,'color': settingsData.font_primary_color ? settingsData.font_primary_color : null  }">
                                {{displayName |uppercase}}
                            </button>
                        </div>
                        <div class="col-md-9 col-xs-9">
                            <div class="f-l mt-6">
                                <span *ngIf="profileName.length <= 16"
                                    [ngStyle]="{'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : ''}"
                                    class="pointer">{{profileName}}
                                </span>
                                <span *ngIf="profileName.length > 16"
                                    [ngStyle]="{'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : ''}"
                                    matTooltipPosition="above" matTooltip="{{profileName}}" class="pointer">
                                    {{profileName | slice: 0:16}}
                                    {{profileName.length > 16 ? "..." : ""}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="c-g">
                        <button *ngIf="isGroupRoute" class="fs-14 mb-20 mt-10 mr-2 logout_box" (click)="goToMainScreen(); rightsidenav.close()" mat-button
                        [matTooltip]="channelDisplayName?.length > 10 ? channelDisplayName : ''" matTooltipPosition="above"
                        [attr.style]="(settingsData.form_font_secondary_color ? 'color: ' + settingsData.form_font_secondary_color + ' !important; ' : '') + 'border-color: #eba921;'">{{channelDisplayName?.length > 10 ? (channelDisplayName | slice:0:10) + '...' : channelDisplayName}}</button>
                        <button class="fs-14 mb-20 mt-10 logout_box" (click)="signout()" mat-button
                        [attr.style]="settingsData.form_font_secondary_color
                        ? 'color: ' + settingsData.form_font_secondary_color + ' !important; border-color: ' + settingsData.form_font_secondary_color + ';'
                        : ''">SIGN
                            OUT</button>
                    </div>
                    <div class="row mt-1">
                    <div class="col-6 text-center" *ngIf="isCryptoWallet==1">

                            <p class="cryptoName mb-1" [ngStyle]="{'color':settingsData?.form_font_secondary_color}">
                                Crypto Wallet
                            </p>
                            <button mat-flat-button class="cryptoButton custom-red-button"  [ngClass]="{'cursor-default': walletID}"
                            [style.border]="'1px soild' + settingsData?.bg_primary_color" [style.background-color]="settingsData?.bg_primary_color + '!important'" [style.color]="settingsData?.font_primary_color">
                                <span *ngIf="walletID== undefined || walletID == '' || walletID == null" (click)="connectToWallet()">Connect</span>
                                <span *ngIf="walletID" matTooltip="{{available_balance}}"><img src="{{cryptoSymbol}}" width="16" class="mb-1 mr-1">{{ crypto_balance }}</span>
                            </button>
                        </div> 

                        <div class="text-center" [ngClass]="{'col-6': isCryptoWallet==1, 'col-12': isCryptoWallet==0}">
                            <p class="cryptoName mb-1" [ngStyle]="{'color':settingsData?.form_font_secondary_color}">
                                Cash Wallet
                            </p>
                            <button mat-flat-button class="cryptoButton custom-red-button"
                                routerLinkActive="router-link-active" *ngIf="!settingsData"
                                [routerLink]="'/' + channelName + '/user-dashboard/cash-wallet'" [attr.style]="
                                (settingsData.bg_primary_color ? 'background-color: ' + settingsData.bg_primary_color + ' !important; ' : '') +
                                (settingsData.font_primary_color ? 'color: ' + settingsData.font_primary_color + ' !important; ' : '') +
                                (settingsData.font_family ? 'font-family: ' + settingsData.font_family + '; ' : '')
                              ">
                                <span *ngIf="walletInfo?.amount != null "> {{walletInfo?.amount
                                    |currency:walletInfo?.currency}}</span>
                                <span *ngIf="walletInfo?.amount == null ">{{0.00
                                    | currency:getCurrency}}</span>
                            </button>
                            <button mat-flat-button class="cryptoButton" routerLinkActive="router-link-active"
                                *ngIf="settingsData" [routerLink]="'/' + channelName + '/user-dashboard/cash-wallet'" [attr.style]="
                                (settingsData.bg_primary_color 
                                  ? 'background-color: ' + settingsData.bg_primary_color + ' !important; ' 
                                  : '') +
                                (settingsData.font_primary_color 
                                  ? 'color: ' + settingsData.font_primary_color + '!important; ' 
                                  : '') +
                                (settingsData.font_family 
                                  ? 'font-family: ' + settingsData.font_family + '; ' 
                                  : '')
                              ">
                                <span *ngIf="walletInfo?.amount != null "> {{walletInfo?.amount
                                    |currency:walletInfo?.currency}}</span>
                                <span *ngIf="walletInfo?.amount == null ">{{0.00
                                    | currency:getCurrency}}</span>
                            </button>
                        </div>
                    </div>
                    <div class="line mt-1"></div>
                    <div class="text-left lh-42 mt-5">
                        <!-- <div>
                  <a class="c-lg ml-25" href="">Category</a>
                </div> -->
                        <div class="pl-20 fw-600" *ngIf="channelUrl=='channel'" fxShow.sm="true" fxHide="true">Channel
                            Menu</div>
                        <div *ngFor="let list of userList" fxShow.sm="true" fxHide="true">
                            <div class="pointer pl-20" *ngIf="channelUrl=='channel'" [ngClass]="{
                                'active-menu': list.activeMenu,
                                'mb-5': list.activeMenu
                              }" (click)="goToUser(list.link,list)">
                                <div class="ml-5 " *ngIf="!list.hide">{{ list.name }}</div>
                            </div>
                        </div>
                        <div class="pl-20 fw-600" *ngIf="channelUrl=='channel'" fxShow.sm="true" fxHide="true">User
                            Dashboard
                        </div>
                        <div class="ic-header-menu" *ngFor="let list of menuList">
                            <div class="pointer pl-20" *ngIf="list.sub_menu && list.sub_menu.length == 0" [ngClass]="{
                                'active-menu': list.activeMenu,'bg-primary':list.activeMenu,
                                'mb-5': list.activeMenu
                              }" (click)="goToMenu(list.link,list)">
                                <div class="menu-name fs-500 ml-5 " *ngIf="!list.hide" [ngStyle]="{'color':settingsData?.form_font_secondary_color}"><i *ngIf="newTopMenu" class="fa tm-icon" [ngClass]="sideMenuIcon(list)" aria-hidden="true"></i>{{ list.name }}</div>
                            </div>

                            <span class="menu-name"
                                [ngStyle]="{'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : ''}"
                                *ngIf="list.sub_menu && list.sub_menu.length > 0">
                                <mat-expansion-panel [expanded]="list.activeMenuList" (opened)="list.activeMenuList"
                                    (closed)="!list.activeMenuList" [ngClass]="{
                  'active-menu': list.activeMenuList,
                  'mb-5': list.activeMenuList
                }" (click)="!newTopMenu && goToMenu(list.link, list)">
                                    <mat-expansion-panel-header [ngClass]="{'bg-primary':list.activeMenuList}"
                                        (click)="newTopMenu && toggleSideGroup(list)">
                                        <mat-panel-title>
                                            <div class="menu-padding pointer">
                                                <span class="menu-name ml-txt"
                                                    [ngStyle]="{'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : ''}"><i
                                                    *ngIf="newTopMenu" class="fa tm-icon" [ngClass]="sideMenuIcon(list)" aria-hidden="true"></i>{{
                                                    list.name }}</span>
                                                <i class="fa fa-angle-right ml-35 mt-5"
                                                    [ngStyle]="{'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : ''}"
                                                    *ngIf="!list.activeMenuList"></i>
                                                <i class="fa fa-angle-down ml-35 mt-5"
                                                    [ngStyle]="{'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : ''}"
                                                    *ngIf="list.activeMenuList"></i>
                                            </div>
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <div fxLayout="column" class="pt-10">
                                        <div class=" menu-name ml-45 pointer" *ngFor="let menu of list.sub_menu"
                                            (click)="navigateSubmenu(menu.link)" [ngClass]="{
                      'active-type': menu.subMenuActive}">
                                            <i *ngIf="newTopMenu" class="fa tm-icon" [ngClass]="sideMenuIcon(menu)" aria-hidden="true"></i>{{menu.menu_name}}
                                        </div>
                                    </div>
                                </mat-expansion-panel>
                            </span>

                        </div>
                    </div>

                </mat-sidenav>

            </mat-sidenav-container>
        </div>
        <!-- <div class="col-1 text-center d-lg-none d-md-none" id="sideNav_mobile">
            <div *ngIf="!loggedIn && !userIdParam" [ngClass]="{'slick-disabled':router.url.includes('/preview')}"
                class=" search-icon-bg" (click)="redirectTo('signin')">
                <i class="fa fa-user"></i>
            </div>
            <div fxShow id="sideNav_mobile" class="artist-pic m-0 text-center pointer" (click)="rightsidenav.toggle()"
                *ngIf="!userInfo?.is_guest && loggedIn && userInfo?.profile_pic != null && userInfo.profile_pic !='' && appType !='native'"
                [ngClass]="{'slick-disabled':router.url.includes('/preview')}"
                [ngStyle]="{'background-image':' url(' + userInfo?.profile_pic + ')'}"></div>
            <button fxShow class="profile-pic notranslate mr-10 text-center lh-31" id="arevea_sideNav"
                (click)="rightsidenav.toggle()"
                *ngIf="!userInfo?.is_guest && loggedIn && (userInfo?.profile_pic == null || userInfo?.profile_pic == '')"
                [ngClass]="{'slick-disabled':router.url.includes('/preview')}"
                [ngStyle]="{'background-color': settingsData.bg_primary_color ? settingsData.bg_primary_color : null ,'color': settingsData.font_primary_color ? settingsData.font_primary_color : null  }">
                <span class="d-inline-block">{{displayName |uppercase}}</span>
            </button>
        </div> -->
    </div>
</div>